import { handleApiError, phpApi } from "../../../api";

export const getData = (id) => {
  return phpApi.post(`/api/survey/${id}/init`).catch(handleApiError);
};

export const saveData = (id, answers) => {
  return phpApi.post(`/api/survey/${id}/save`, { answers }).catch(handleApiError);
};

export const finishForm = (id) => {
  return phpApi.post(`/api/survey/${id}/finish`).catch(handleApiError);
};
